const REQ_URL = process.env.REACT_APP_REQ_URL || "http://localhost:3333";
export const reqUrl = (path: string) => `${REQ_URL}${path}`;
